<template>
  <div class="addr-three-select">
    <el-select class="select" v-model="level1" @change="selectChangeHandler" value-key="code">
      <el-option v-for="item in listData.level1" :key="item.code" :value="item" :label="item.name"></el-option>
    </el-select>
    <el-select class="select" v-show="level1" @change="selectChangeHandler" v-model="level2" value-key="code">
      <el-option v-for="item in listData.level2" :key="item.code" :value="item" :label="item.name"></el-option>
    </el-select>
    <el-select class="select" v-show="level2" v-model="level3" @change="selectChangeHandler" value-key="code">
      <el-option v-for="item in listData.level3" :key="item.code" :value="item" :label="item.name"></el-option>
    </el-select>
  </div>
</template>

<script>
  export default {
    name: 'AddrThreeSelect',
    props: {
      code: String,
    },
    model: {
      prop: 'code',
      event: 'change',
    },
    data() {
      return {
        level1: '',
        level2: '',
        level3: '',
        listData: {
          level1: [],
          level2: [],
          level3: [],
        },
        hasSelect: false, // 当前的值是否是选择产生
      }
    },
    watch: {
      code(nv, ov) {
        // 只有在两个值不同，且 不是通过select选择的值
        if (nv !== ov && !this.hasSelect){
          this.computeCode(nv)
        }
        // 重置标识
        this.hasSelect = false

      },
    },
    methods: {
      /**
       * 加载数据
       * @param code
       * @param level
       */
      loadRegions(code, level) {
        this.$api.common.regions(code).then(res => {
          if (res.code === 0) {
            this.listData[level] = res.data
          }
        })
      },
      selectChangeHandler(data) {
        let level = data.level
        // 根据当前选择的级别去除后面的已选择数据
        if (level <= 2) {
          this.level3 = ''
        }
        if (level === 1) {
          this.level2 = ''
        }
        if (level < 3) {
          // 小于3级需要加载数据
          this.loadRegions(data.code, `level${ level + 1 }`)
        } else {
          this.hasSelect = true
          this.$emit('change', data.code)
        }
      },
      /**
       * 根据县级地址码推算出完整的地址码
       * @param code
       * @returns
       */
      computeCode(code) {
        // 如果code是00结尾，表示不是县级地址码
        if (code.length < 6 || code.endsWith('00')){
          this.level1 = ''
          this.level2 = ''
          this.level3 = ''
          return
        }
        this.level1 = {code: code.substring(0, 2) + '0'.repeat(4)}
        this.loadRegions(this.level1.code, 'level2')
        this.level2= {code: code.substring(0, 4) + '0'.repeat(2)}
        this.loadRegions(this.level2.code, 'level3')
        this.level3 = {code}
      },
    },
    created() {
      this.loadRegions('', 'level1')
      if (this.code.length===6){
        this.computeCode(this.code)
      }
    },
  }
</script>

<style scoped>
  .addr-three-select {
    width: 465px;
  }

  .select {
    width: 120px;
    margin-right: 5px;
  }
</style>
